var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Filter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Filter",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.8,0 C5.462736,0 6,0.537264 6,1.2 L6,10.8 C7.98822,10.8 9.6,12.41172 9.6,14.4 C9.6,16.38828 7.98822,18 6,18 L6,22.8 C6,23.46276 5.462748,24 4.8,24 C4.137264,24 3.6,23.46276 3.6,22.8 L3.6,18 C1.61178,18 0,16.38828 0,14.4 C0,12.41172 1.61178,10.8 3.6,10.8 L3.6,1.2 C3.6,0.537264 4.137264,0 4.8,0 Z M19.2,0 C19.86276,0 20.4,0.537264 20.4,1.2 L20.4,13.2 C22.38828,13.2 24,14.81172 24,16.8 C24,18.78828 22.38828,20.4 20.4,20.4 L20.4,22.8 C20.4,23.46276 19.86276,24 19.2,24 C18.53724,24 18,23.46276 18,22.8 L18,20.4 C16.01172,20.4 14.4,18.78828 14.4,16.8 C14.4,14.81172 16.01172,13.2 18,13.2 L18,1.2 C18,0.537264 18.53724,0 19.2,0 Z M12,0 C12.66276,0 13.2,0.537264 13.2,1.2 L13.2,3.6 C15.18828,3.6 16.8,5.21178 16.8,7.2 C16.8,9.18822 15.18828,10.8 13.2,10.8 L13.2,22.8 C13.2,23.46276 12.66276,24 12,24 C11.33724,24 10.8,23.46276 10.8,22.8 L10.8,10.8 C8.81178,10.8 7.2,9.18822 7.2,7.2 C7.2,5.21178 8.81178,3.6 10.8,3.6 L10.8,1.2 C10.8,0.537264 11.33724,0 12,0 Z M20.4,15.6 L18,15.6 C17.33724,15.6 16.8,16.13724 16.8,16.8 C16.8,17.46276 17.33724,18 18,18 L20.4,18 C21.06276,18 21.6,17.46276 21.6,16.8 C21.6,16.13724 21.06276,15.6 20.4,15.6 Z M6,13.2 L3.6,13.2 C2.937264,13.2 2.4,13.73724 2.4,14.4 C2.4,15.06276 2.937264,15.6 3.6,15.6 L6,15.6 C6.662736,15.6 7.2,15.06276 7.2,14.4 C7.2,13.73724 6.662736,13.2 6,13.2 Z M13.2,6 L10.8,6 C10.13724,6 9.6,6.537264 9.6,7.2 C9.6,7.862736 10.13724,8.4 10.8,8.4 L13.2,8.4 C13.86276,8.4 14.4,7.862736 14.4,7.2 C14.4,6.537264 13.86276,6 13.2,6 Z",
    fill: "#171A33"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.86eff3a85a97b0cea33f1f574c5a71ab.svg";
export { ForwardRef as ReactComponent };